/* tslint:disable */
/* eslint-disable */
/**
 * sqsAccessManage API
 * SQSに登録する・登録された情報を操作するAPI群
 *
 * The version of the OpenAPI document: 1.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 非同期処理の個別ステータス情報
 * @export
 * @interface AsyncProcessStatusItem
 */
export interface AsyncProcessStatusItem {
    /**
     * 組織ID
     * @type {string}
     * @memberof AsyncProcessStatusItem
     */
    'organizationId': string;
    /**
     * ユーザID
     * @type {string}
     * @memberof AsyncProcessStatusItem
     */
    'userId': string;
    /**
     * 処理のステータス (pending, processing, completed, failed)
     * @type {string}
     * @memberof AsyncProcessStatusItem
     */
    'status': AsyncProcessStatusItemStatusEnum;
    /**
     * リクエストID
     * @type {string}
     * @memberof AsyncProcessStatusItem
     */
    'requestId': string;
    /**
     * 処理種別
     * @type {string}
     * @memberof AsyncProcessStatusItem
     */
    'actionType'?: string;
    /**
     * 処理結果（completed時のみ存在）
     * @type {object}
     * @memberof AsyncProcessStatusItem
     */
    'result'?: object;
    /**
     * エラーメッセージ（failed時のみ存在）
     * @type {string}
     * @memberof AsyncProcessStatusItem
     */
    'errorMessage'?: string;
}

export const AsyncProcessStatusItemStatusEnum = {
    Pending: 'pending',
    Processing: 'processing',
    Completed: 'completed',
    Failed: 'failed'
} as const;

export type AsyncProcessStatusItemStatusEnum = typeof AsyncProcessStatusItemStatusEnum[keyof typeof AsyncProcessStatusItemStatusEnum];

/**
 * 非同期処理ステータス削除レスポンス
 * @export
 * @interface DeleteAsyncProcessStatusResponse
 */
export interface DeleteAsyncProcessStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteAsyncProcessStatusResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteAsyncProcessStatusResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteAsyncProcessStatusResponse
     */
    'message': string;
    /**
     * 
     * @type {DeleteAsyncProcessStatusResponseInfo}
     * @memberof DeleteAsyncProcessStatusResponse
     */
    'result': DeleteAsyncProcessStatusResponseInfo;
}
/**
 * 非同期処理ステータス削除レスポンスの結果情報
 * @export
 * @interface DeleteAsyncProcessStatusResponseInfo
 */
export interface DeleteAsyncProcessStatusResponseInfo {
    /**
     * 削除結果メッセージ
     * @type {string}
     * @memberof DeleteAsyncProcessStatusResponseInfo
     */
    'message': string;
}
/**
 * DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を削除するAPIのレスポンス
 * @export
 * @interface DeleteSqsStatusInfoFromDynamoDbResponse
 */
export interface DeleteSqsStatusInfoFromDynamoDbResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteSqsStatusInfoFromDynamoDbResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteSqsStatusInfoFromDynamoDbResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteSqsStatusInfoFromDynamoDbResponse
     */
    'message': string;
    /**
     * 
     * @type {DeleteSqsStatusInfoFromDynamoDbResponseInfo}
     * @memberof DeleteSqsStatusInfoFromDynamoDbResponse
     */
    'result': DeleteSqsStatusInfoFromDynamoDbResponseInfo;
}
/**
 * DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を削除するAPIのレスポンス
 * @export
 * @interface DeleteSqsStatusInfoFromDynamoDbResponseInfo
 */
export interface DeleteSqsStatusInfoFromDynamoDbResponseInfo {
    /**
     * メッセージ
     * @type {string}
     * @memberof DeleteSqsStatusInfoFromDynamoDbResponseInfo
     */
    'message': string;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 非同期処理ステータスポーリングレスポンス
 * @export
 * @interface GetAsyncProcessStatusResponse
 */
export interface GetAsyncProcessStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof GetAsyncProcessStatusResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetAsyncProcessStatusResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetAsyncProcessStatusResponse
     */
    'message': string;
    /**
     * 非同期処理ステータスの配列
     * @type {Array<AsyncProcessStatusItem>}
     * @memberof GetAsyncProcessStatusResponse
     */
    'result': Array<AsyncProcessStatusItem>;
}
/**
 * DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を取得するAPIのレスポンス
 * @export
 * @interface GetSqsMessageResponse
 */
export interface GetSqsMessageResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSqsMessageResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetSqsMessageResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetSqsMessageResponse
     */
    'message': string;
    /**
     * DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を取得するAPIのレスポンス
     * @type {Array<GetSqsMessageResponseInfoInner>}
     * @memberof GetSqsMessageResponse
     */
    'result': Array<GetSqsMessageResponseInfoInner>;
}
/**
 * 
 * @export
 * @interface GetSqsMessageResponseInfoInner
 */
export interface GetSqsMessageResponseInfoInner {
    /**
     * 組織ID
     * @type {string}
     * @memberof GetSqsMessageResponseInfoInner
     */
    'organizationId': string;
    /**
     * ユーザID
     * @type {string}
     * @memberof GetSqsMessageResponseInfoInner
     */
    'userId': string;
    /**
     * 処理の進行状況
     * @type {string}
     * @memberof GetSqsMessageResponseInfoInner
     */
    'status': string;
    /**
     * リクエストID
     * @type {string}
     * @memberof GetSqsMessageResponseInfoInner
     */
    'requestId': string;
}
/**
 * 非同期処理キックリクエスト
 * @export
 * @interface PostAsyncProcessRequest
 */
export interface PostAsyncProcessRequest {
    /**
     * 処理種別 (sample, single-simulation, register-business)
     * @type {string}
     * @memberof PostAsyncProcessRequest
     */
    'actionType': PostAsyncProcessRequestActionTypeEnum;
    /**
     * 処理に渡すペイロードデータ
     * @type {object}
     * @memberof PostAsyncProcessRequest
     */
    'payload'?: object;
}

export const PostAsyncProcessRequestActionTypeEnum = {
    Sample: 'sample',
    SingleSimulation: 'single-simulation',
    RegisterBusiness: 'register-business'
} as const;

export type PostAsyncProcessRequestActionTypeEnum = typeof PostAsyncProcessRequestActionTypeEnum[keyof typeof PostAsyncProcessRequestActionTypeEnum];

/**
 * 非同期処理キックレスポンス（202 Accepted相当）
 * @export
 * @interface PostAsyncProcessResponse
 */
export interface PostAsyncProcessResponse {
    /**
     * 
     * @type {number}
     * @memberof PostAsyncProcessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostAsyncProcessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostAsyncProcessResponse
     */
    'message': string;
    /**
     * 
     * @type {PostAsyncProcessResponseInfo}
     * @memberof PostAsyncProcessResponse
     */
    'result': PostAsyncProcessResponseInfo;
}
/**
 * 非同期処理キックレスポンスの結果情報
 * @export
 * @interface PostAsyncProcessResponseInfo
 */
export interface PostAsyncProcessResponseInfo {
    /**
     * ポーリングで使用するリクエストID
     * @type {string}
     * @memberof PostAsyncProcessResponseInfo
     */
    'requestId': string;
    /**
     * 処理のステータス (pending)
     * @type {string}
     * @memberof PostAsyncProcessResponseInfo
     */
    'status': string;
    /**
     * 処理種別
     * @type {string}
     * @memberof PostAsyncProcessResponseInfo
     */
    'actionType': string;
}
/**
 * SQSにメッセージを登録するAPIのレスポンス
 * @export
 * @interface PostSqsMessageResponse
 */
export interface PostSqsMessageResponse {
    /**
     * 
     * @type {number}
     * @memberof PostSqsMessageResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostSqsMessageResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostSqsMessageResponse
     */
    'message': string;
    /**
     * 
     * @type {PostSqsMessageResponseInfo}
     * @memberof PostSqsMessageResponse
     */
    'result': PostSqsMessageResponseInfo;
}
/**
 * SQSにメッセージを登録するAPIのレスポンス
 * @export
 * @interface PostSqsMessageResponseInfo
 */
export interface PostSqsMessageResponseInfo {
    /**
     * SQSに登録されたメッセージのID
     * @type {string}
     * @memberof PostSqsMessageResponseInfo
     */
    'MessageId': string;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}

/**
 * AsyncProcessApi - axios parameter creator
 * @export
 */
export const AsyncProcessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 非同期処理のステータス情報をDynamoDBから削除する
         * @param {string} requestId リクエストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsyncProcessStatus: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('deleteAsyncProcessStatus', 'requestId', requestId)
            const localVarPath = `/async-process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (requestId !== undefined) {
                localVarQueryParameter['request-id'] = requestId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非同期処理のステータスをポーリングで取得する
         * @param {string} [actionType] 処理種別でフィルタリング (例: single-simulation, register-business)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsyncProcessStatus: async (actionType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/async-process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (actionType !== undefined) {
                localVarQueryParameter['actionType'] = actionType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 非同期処理をキックする（S3保存→DynamoDB登録→SQS送信）
         * @param {PostAsyncProcessRequest} postAsyncProcessRequest 非同期処理のリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAsyncProcess: async (postAsyncProcessRequest: PostAsyncProcessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postAsyncProcessRequest' is not null or undefined
            assertParamExists('postAsyncProcess', 'postAsyncProcessRequest', postAsyncProcessRequest)
            const localVarPath = `/async-process`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postAsyncProcessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AsyncProcessApi - functional programming interface
 * @export
 */
export const AsyncProcessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AsyncProcessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 非同期処理のステータス情報をDynamoDBから削除する
         * @param {string} requestId リクエストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAsyncProcessStatus(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteAsyncProcessStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAsyncProcessStatus(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AsyncProcessApi.deleteAsyncProcessStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非同期処理のステータスをポーリングで取得する
         * @param {string} [actionType] 処理種別でフィルタリング (例: single-simulation, register-business)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAsyncProcessStatus(actionType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAsyncProcessStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAsyncProcessStatus(actionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AsyncProcessApi.getAsyncProcessStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 非同期処理をキックする（S3保存→DynamoDB登録→SQS送信）
         * @param {PostAsyncProcessRequest} postAsyncProcessRequest 非同期処理のリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAsyncProcess(postAsyncProcessRequest: PostAsyncProcessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostAsyncProcessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAsyncProcess(postAsyncProcessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AsyncProcessApi.postAsyncProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AsyncProcessApi - factory interface
 * @export
 */
export const AsyncProcessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AsyncProcessApiFp(configuration)
    return {
        /**
         * 
         * @summary 非同期処理のステータス情報をDynamoDBから削除する
         * @param {string} requestId リクエストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAsyncProcessStatus(requestId: string, options?: any): AxiosPromise<DeleteAsyncProcessStatusResponse> {
            return localVarFp.deleteAsyncProcessStatus(requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非同期処理のステータスをポーリングで取得する
         * @param {string} [actionType] 処理種別でフィルタリング (例: single-simulation, register-business)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsyncProcessStatus(actionType?: string, options?: any): AxiosPromise<GetAsyncProcessStatusResponse> {
            return localVarFp.getAsyncProcessStatus(actionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 非同期処理をキックする（S3保存→DynamoDB登録→SQS送信）
         * @param {PostAsyncProcessRequest} postAsyncProcessRequest 非同期処理のリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAsyncProcess(postAsyncProcessRequest: PostAsyncProcessRequest, options?: any): AxiosPromise<PostAsyncProcessResponse> {
            return localVarFp.postAsyncProcess(postAsyncProcessRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AsyncProcessApi - object-oriented interface
 * @export
 * @class AsyncProcessApi
 * @extends {BaseAPI}
 */
export class AsyncProcessApi extends BaseAPI {
    /**
     * 
     * @summary 非同期処理のステータス情報をDynamoDBから削除する
     * @param {string} requestId リクエストID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncProcessApi
     */
    public deleteAsyncProcessStatus(requestId: string, options?: RawAxiosRequestConfig) {
        return AsyncProcessApiFp(this.configuration).deleteAsyncProcessStatus(requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非同期処理のステータスをポーリングで取得する
     * @param {string} [actionType] 処理種別でフィルタリング (例: single-simulation, register-business)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncProcessApi
     */
    public getAsyncProcessStatus(actionType?: string, options?: RawAxiosRequestConfig) {
        return AsyncProcessApiFp(this.configuration).getAsyncProcessStatus(actionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 非同期処理をキックする（S3保存→DynamoDB登録→SQS送信）
     * @param {PostAsyncProcessRequest} postAsyncProcessRequest 非同期処理のリクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AsyncProcessApi
     */
    public postAsyncProcess(postAsyncProcessRequest: PostAsyncProcessRequest, options?: RawAxiosRequestConfig) {
        return AsyncProcessApiFp(this.configuration).postAsyncProcess(postAsyncProcessRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SqsAccessManageApi - axios parameter creator
 * @export
 */
export const SqsAccessManageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を削除する
         * @param {string} requestId リクエストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSqsStatusInfoFromDynamoDb: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('deleteSqsStatusInfoFromDynamoDb', 'requestId', requestId)
            const localVarPath = `/sqs-status-info-in-dynamodb`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (requestId !== undefined) {
                localVarQueryParameter['request-id'] = requestId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSqsMessage: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sample-sqs-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SQSにメッセージを登録する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSqsMessage: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sample-sqs-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SqsAccessManageApi - functional programming interface
 * @export
 */
export const SqsAccessManageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SqsAccessManageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を削除する
         * @param {string} requestId リクエストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSqsStatusInfoFromDynamoDb(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteSqsStatusInfoFromDynamoDbResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSqsStatusInfoFromDynamoDb(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SqsAccessManageApi.deleteSqsStatusInfoFromDynamoDb']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSqsMessage(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSqsMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSqsMessage(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SqsAccessManageApi.getSqsMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary SQSにメッセージを登録する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postSqsMessage(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostSqsMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postSqsMessage(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SqsAccessManageApi.postSqsMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SqsAccessManageApi - factory interface
 * @export
 */
export const SqsAccessManageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SqsAccessManageApiFp(configuration)
    return {
        /**
         * 
         * @summary DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を削除する
         * @param {string} requestId リクエストID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSqsStatusInfoFromDynamoDb(requestId: string, options?: any): AxiosPromise<DeleteSqsStatusInfoFromDynamoDbResponse> {
            return localVarFp.deleteSqsStatusInfoFromDynamoDb(requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSqsMessage(options?: any): AxiosPromise<GetSqsMessageResponse> {
            return localVarFp.getSqsMessage(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SQSにメッセージを登録する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postSqsMessage(options?: any): AxiosPromise<PostSqsMessageResponse> {
            return localVarFp.postSqsMessage(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SqsAccessManageApi - object-oriented interface
 * @export
 * @class SqsAccessManageApi
 * @extends {BaseAPI}
 */
export class SqsAccessManageApi extends BaseAPI {
    /**
     * 
     * @summary DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を削除する
     * @param {string} requestId リクエストID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SqsAccessManageApi
     */
    public deleteSqsStatusInfoFromDynamoDb(requestId: string, options?: RawAxiosRequestConfig) {
        return SqsAccessManageApiFp(this.configuration).deleteSqsStatusInfoFromDynamoDb(requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary DynamoDBに登録されたSQSをトリガーに実行された処理の進行状況を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SqsAccessManageApi
     */
    public getSqsMessage(options?: RawAxiosRequestConfig) {
        return SqsAccessManageApiFp(this.configuration).getSqsMessage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SQSにメッセージを登録する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SqsAccessManageApi
     */
    public postSqsMessage(options?: RawAxiosRequestConfig) {
        return SqsAccessManageApiFp(this.configuration).postSqsMessage(options).then((request) => request(this.axios, this.basePath));
    }
}



